import axios from "axios";
import { GET_MANAGEMENT_COMPANY_FAILURE, GET_MANAGEMENT_COMPANY_REQUEST, GET_MANAGEMENT_COMPANY_SUCCESS } from "../constants/management-company.constants";
import { AnyIfEmpty } from "react-redux";
import { Dispatch } from "react";

export const getManagementCompanyRequest = () => {
    return {
        type: GET_MANAGEMENT_COMPANY_REQUEST,
    };
};

export const getManagementCompanySuccess = (managementCompany: AnyIfEmpty<object>) => {
    return {
        type: GET_MANAGEMENT_COMPANY_SUCCESS,
        payload: managementCompany,
    };
};

export const getManagementCompanyFailure = (errorMessage: string) => {
    return {
        type: GET_MANAGEMENT_COMPANY_FAILURE,
        payload: errorMessage,
    };
};

export const getManagementCompany = (searchText?: string) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getManagementCompanyRequest());
        axios.get(`/admin/locations/management-company`, {
            params: {
                searchText: searchText,
            },
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    const list = response.data?.data ?? response.data?.managementCompanies ?? response.data ?? [];
                    dispatch(getManagementCompanySuccess(Array.isArray(list) ? list : []));
                } else {
                    dispatch(getManagementCompanyFailure(response.data.message));
                }
            })
            .catch((error) => {
                dispatch(getManagementCompanyFailure(error.response.data.message));
            });
    };
};